export default {"src":"/_next/static/media/arrow-cursor.e662001b.svg","height":74,"width":73,"blurWidth":0,"blurHeight":0};